import React, { useState } from 'react';

import { Grid, Typography, IconButton, Tooltip } from '@material-ui/core';
import Button from 'components/Button/Button';
import Modal from 'components/Modal';

export default function ButtonConfirmation({
  title,
  startIcon,
  endIcon,
  color,
  iconButton,
  variant,
  fullWidth,
  type = 'button',
  loading,
  disabled,
  maxWidth = 'sm',
  isButtonDisabled,
  isCancelButton = true,
  cancelTitle = 'Cancelar',
  cancelColor = 'error',
  cancelVariant = 'outlined',
  cancelFullWidth = false,
  modalTitle,
  modalText,
  modalButtons,
  closeOnConfirm = true,
  tooltip = '',
  fontSize,
  ...props
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return(
    <>
      {isModalOpen && (
        <Modal
          id="button-confirmation-modal"
          title={modalTitle}
          scroll="body"
          maxWidth={maxWidth}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <Typography>{modalText}</Typography>
          <Grid container>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 10 }}>
              {isCancelButton && (
                <Button
                  fullWidth={cancelFullWidth}
                  color={cancelColor}
                  variant={cancelVariant}
                  onClick={() => setIsModalOpen(false)}
                >
                  {cancelTitle}
                </Button>
              )}
              {modalButtons?.map(button => {
                return(
                  <Button
                    disabled={isButtonDisabled}
                    fullWidth={button?.fullWidth}
                    color={button?.color}
                    onClick={() => {
                      if(!closeOnConfirm) {
                        return button?.onClick();
                      }

                      if(closeOnConfirm) {
                        return(
                          setIsModalOpen(false),
                          button?.onClick()
                        );
                      }
                    }}
                  >
                    {button?.title}
                  </Button>
                );
              })}
            </Grid>
          </Grid>
        </Modal>
      )}
      {iconButton ? (
        <Tooltip
          placement='top'
          title={tooltip ? tooltip : ''}
          enterTouchDelay={0}
        >
          <IconButton
            {...props}
            onClick={() => setIsModalOpen(true)}
          >
            {iconButton}
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          {...props}
          loading={loading}
          fontSize={fontSize}
          type={type}
          disabled={disabled}
          fullWidth={fullWidth}
          color={color}
          variant={variant}
          startIcon={startIcon}
          endIcon={endIcon}
          onClick={() => setIsModalOpen(true)}
        >
          {title}
        </Button>
      )}
    </>
  );
}